import { useState } from 'react';
import { useSession, useVendedoresCaja, type TurnoCaja } from '@almacenes/core';
import { readPrintConfig, printTicketHtml } from './usePrintConfig';
import { buildComprobanteTurnoHtml } from '../utils/comprobante-turno-html';

const ESTADOS: Record<string, string> = {
  ABIERTO: 'Abierto',
  CERRADO: 'Cerrado',
  CERRADO_FORZADO: 'Cerrado por administración',
};

export const usePrintComprobanteTurno = () => {
  const { data: session } = useSession();
  const { data: vendedores } = useVendedoresCaja();
  const [imprimiendo, setImprimiendo] = useState(false);

  const nombreVendedor = (usuarioId: number): string => {
    if (session?.user?.id === usuarioId) return session.user.nombre;
    return vendedores?.find((v) => v.id === usuarioId)?.nombreMostrable ?? `Usuario #${usuarioId}`;
  };

  const imprimirComprobante = async (turno: TurnoCaja) => {
    setImprimiendo(true);
    try {
      const printConfig = readPrintConfig();
      const contenido = buildComprobanteTurnoHtml(
        {
          almacenNombre: session?.almacen?.nombre ?? '',
          almacenRut: session?.almacen?.rut ?? null,
          almacenDireccion: session?.almacen?.direccion ?? null,
          vendedor: nombreVendedor(turno.usuarioId),
          estado: ESTADOS[turno.estado] ?? turno.estado,
          fechaHoraApertura: turno.fechaHoraApertura,
          fechaHoraCierre: turno.fechaHoraCierre,
          montoInicial: turno.montoInicial,
          ventasPorMedioPago: turno.ventasPorMedioPago ?? {},
          totalVentas: turno.totalVentas,
          totalIngresos: turno.totalIngresos,
          totalIngresosEfectivo: turno.totalIngresosEfectivo,
          totalEgresos: turno.totalEgresos,
          efectivoEsperado: turno.efectivoEsperado,
          arqueoRealizado: turno.arqueoRealizado,
          efectivoContado: turno.efectivoContado,
          diferenciaEfectivo: turno.diferenciaEfectivo,
          motivoCierre: turno.motivoCierre,
        },
        printConfig
      );
      await printTicketHtml(contenido, printConfig);
    } catch (error) {
      console.error('Error al imprimir el comprobante de turno:', error);
    } finally {
      setImprimiendo(false);
    }
  };

  return { imprimirComprobante, imprimiendo };
};
